<template>
    <div id="inquiryadmin">
        <nav>
            <div class="leftNav">
                <div class="innerNav">
                    <img class="navLogout" v-on:click="openNav()" src="/assets/burger.png" alt="burger" />
                </div>
            </div>
            <center>
                <img class="main" v-on:click="reload()" src="/assets/logo.png" alt="SO" />
            </center>
            <div class="rightNav">
                <div class="innerNav">
                    <span class="pNav">
                        {{Name}}
                    </span>
                    <img class="logoNav" src="/assets/adpr.png" alt="ADPR" />
                </div>
            </div>
            <div class="sideNav" :style="{ width: navWidth + 'px' }">
                <div class="leftNav">
                    <div class="innerNav">
                        <img class="navLogout" v-on:click="openNav()" src="/assets/burgerwhite.png" alt="burger" />
                    </div>
                </div>
                <div v-if="navMenuVisible" class="navsidecontent">
                    <div class="navtitle noborder">
                        Gérer les biens et demandes
                    </div>
                    <div v-on:click="goToNewBuildingPage" class="navsubtitle">
                        Créer un nouveau bien
                    </div>
                    <div v-on:click="goToBuildingPage" class="navsubtitle">
                        Consulter/Modifier les biens et demandes
                    </div>
                    <div class="navtitle">
                        Plannings
                    </div>
                    <div v-on:click="goToPlanningPage" class="navsubtitle">
                        Consulter/Modifier les plannings
                    </div>
                    <div v-on:click="goToTimeSheetPage" class="navsubtitle">
                        Fiches horaires
                    </div>
                    <div class="navtitle">
                        Groupes
                    </div>
                    <div v-on:click="goToNewGroupPage" class="navsubtitle">
                        Ajouter un groupe
                    </div>
                    <div v-on:click="goToAllGroupPage" class="navsubtitle">
                        Voir/Modifier les groupes
                    </div>
                    <div class="navtitle">
                        Utilisateurs
                    </div>
                    <div v-on:click="goToNewUserPage" class="navsubtitle">
                        Ajouter un utilisateur
                    </div>
                    <div v-on:click="goToAllUserPage" class="navsubtitle">
                        Voir/Modifier les utilisateurs
                    </div>
                    <div v-on:click="logout()" class="navtitle logout">
                        Déconnexion
                    </div>
                </div>
            </div>
        </nav>
        <div class="filAriane">
            <span v-html="filAriane"></span>
        </div>
        <div class="outercircle">
            <div class="homeName">
                Affaire suivie par {{followedBy}}
            </div>
        </div>
        <h1>
            <button v-on:click="backbtn()" class="btnBack">
                <font-awesome-icon icon="arrow-alt-circle-left" />
            </button>
            Documents
        </h1>
        <div class="divCard">
            <span class="spanCardtitle">
            Devis
            </span>
            <span class="spanCardtype">
                <i>{{quotStatus}}</i>
            </span>
            
            <input v-if="!inquiry.quotation" type="file" ref="file" @change="onQuotationSelected" style="display: none">
            <button v-if="!inquiry.quotation" @click="$refs.file.click()" class="baseBtn docBtn">Ajouter</button>
            <button v-else v-on:click="goToQuotationPage(inquiry.quotation._id)" class="baseBtn docBtn">{{quotBtn}}</button>
        </div>
        <div class="divCard">
            <span class="spanCardtitle">
            Facture
            </span>
            <span class="spanCardtype">
                <i>{{invStatus}}</i>
            </span>
            
            <modal height="250px" name="invoiceParam">
                <div class="modalDiv">
                    <div class="txtDiv">
                        <span class="modalTxt">Montant total de la facture en Euros :</span>
                        <input class="modalAmount" type="text"  v-model="amount" placeholder="99.00"><br>
                    </div>    
                    <div class="txtDiv">
                        <span class="modalTxt">Réglement de la facture en ligne ?</span>
                        <input class="modalCheck" type="checkbox" v-model="rolesSelected">
                    </div>    
                    <input type="file" ref="file2" @change="onInvoiceSelected" style="display: none"><br>
                    <button class="docBtn3" type="button" @click="$refs.file2.click()">Selectionner Un PDF</button>   
                </div>    
            </modal>

            <button v-if="!inquiry.invoice" v-on:click="openModal()" @click="$refs.file2.click()" class="baseBtn docBtn">Ajouter</button>
            <button v-else v-on:click="goToInvoicePage(inquiry.invoice._id)" class="baseBtn docBtn">{{invBtn}}</button>
        </div>
        <div class="divCard">
            
            <modal width="80%" height="250px" name="notes">
                <div class="modalDiv">
                    <div class="txtDiv">
                        <textarea rows="10" class="modalNotes" type="text"  v-model="inquiry.note" :placeholder="inquiry.note"></textarea><br>
                    </div> 
                    <button class="docBtn3" type="button" v-on:click="modifyNotes()">Enregistrer  la note</button>   
                </div>    
            </modal>
            <span class="spanCardtitle">
                Bloc notes
            </span>
            <span class="spanCardtype">
                <i>{{noteInq}}</i>
            </span>
            <button v-on:click="goToNotePage()" class="baseBtn docBtn">Modifier</button>
        </div>
        <div class="divCard">
            <span class="spanCardtitle">
                Documents ({{nbDocs}})
            </span>
            <span class="spanCardtype">
                <i v-if="inquiry.TVAsheet">Fiche TVA,&nbsp;&nbsp;&nbsp;</i>
                <i v-if="inquiry.climsheet">Fiche produits dangereux,&nbsp;&nbsp;&nbsp;</i>
                <i v-if="inquiry.gazsheet">Fiche entretien gaz,&nbsp;&nbsp;&nbsp;</i>
                <i v-if="inquiry.fioulsheet">Fiche entretien fioul,&nbsp;&nbsp;&nbsp;</i>
                <i v-for="(item, index) in inquiry.document" :key="index">
                    <span v-if="index === inquiry.document.length-1">{{item.name}}</span>
                    <span v-else>{{item.name}},&nbsp;&nbsp;&nbsp;</span>
                </i>
            </span>
            <button v-on:click="goToInquiryDocumentsPage(inquiry.name)" class="baseBtn docBtn">Ajouter</button>
        </div>
        <div class="outermargin"></div>
        <h1>Demande {{inquiry.name}} &nbsp;&nbsp;-&nbsp;&nbsp; {{inquiry.type}}</h1>
        <div v-if="inquiry.intervention">
            <div v-if="inquiry.intervention.length">
                <div v-for="(item, index) in inquiry.intervention" :key="index">
                    <div class="divCard">
                        <span class="spanCardtitle">
                        {{ item.name}}
                        </span>
                        <span class="spanCardtype">
                            <i>{{getDateOfIntervention(item.planning[0].startTimestamp)}} &nbsp;&nbsp;-&nbsp;&nbsp; {{item.type}}</i>
                        </span>
                        <span class="spanCardstatus">
                        {{item.status}}
                        </span>
                        <button v-on:click="goToInterventionPage(item._id)" class="btnCard"><font-awesome-icon icon="chevron-right" /></button>
                    </div>
                </div>
            </div>
            <div v-else>
                <span class="btnAccordion btnAccordionNone">
                    Aucune intervention sur cette demande
                </span>
            </div>
        </div>
        <div v-else>
            <span class="btnAccordion btnAccordionNone">
                Aucune intervention sur cette demande
            </span>
        </div>
        <div class="divCard">
            <span class="spanCardtitle">
                Créer une nouvelle intervention
            </span>
            <button class="btnNewBtn" v-on:click="goToNewIntervention(inquiry.name)"><font-awesome-icon icon="plus" /></button>
        </div>
        <div class="outercircle">
            <button id="modify" type="button" v-on:click="goToModifyInquiry()">Modifier la demande</button>
        </div>
        <div class="outerTime">
            <div class="timeCumulated">
                Temps cumulé technicien principal : {{displayTime(mainTechTime)}} 
                <span v-if="mainTechTimeDist">&nbsp;&nbsp;(dont {{displayTime(mainTechTimeDist)}} en déplacement)</span><br>
                Temps cumulé aide : {{displayTime(otherTechTime)}}
                <span v-if="otherTechTimeDist">&nbsp;&nbsp;(dont {{displayTime(otherTechTimeDist)}} en déplacement)</span><br>
                Temps cumulé intérimaire : {{displayTime(interimTechTime)}}
                <span v-if="interimTechTimeDist">&nbsp;&nbsp;(dont {{displayTime(interimTechTimeDist)}} en déplacement)</span><br>
                <hr>
                <b>Temps cumulé total : {{displayTime(mainTechTime+otherTechTime+interimTechTime)}}
                <span v-if="(mainTechTimeDist+otherTechTimeDist+interimTechTimeDist)">&nbsp;&nbsp;(dont {{displayTime(mainTechTimeDist+otherTechTimeDist+interimTechTimeDist)}} en déplacement)</span></b><br>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    export default {
        name: 'Inquiryadmin',
        data() {
            return {
                inquiry : {},
                nbDocs:0,
                Name:"client",
                followedBy:"ADPR",
                quotStatus:"pas de devis",
                quotBtn:"Voir",
                noteInq:"pas de notes",
                invStatus:"pas de facture",
                invBtn:"Voir",
                amount:99.99,
                rolesSelected:false,
                mainTechTime:0,
                otherTechTime:0,
                interimTechTime:0,
                mainTechTimeDist:0,
                otherTechTimeDist:0,
                interimTechTimeDist:0,
                navWidth:0,
                navMenuVisible:false,
                filAriane: ""
            };
        },
        methods:{
            logout() {
                this.$cookie.delete('jwt');
                this.$cookie.delete('role');
                this.$cookie.delete('firstName');
                this.$cookie.delete('lastName');
                this.$cookie.delete('currentAriane');
                this.$cookie.delete('historyQuery');
                this.$cookie.delete('history');
                this.$router.replace({ name: "login" });
            },
            onQuotationSelected(event){
                this.files = event.target.files;
                var extension = this.files[0].name.substring(this.files[0].name.lastIndexOf(".")+1).toLowerCase();
                if(extension !== "pdf"){
                    alert("Image au mauvais format, veuillez réessayer avec un fichier PDF");
                }
                else{
                    this.modifyQuotation();
                }               
            },
            goToNewIntervention(name){
                var strHist = this.$cookie.get('history');
                var arrHist = JSON.parse(strHist);

                var strQuery = this.$cookie.get('historyQuery');
                var arrQuery = JSON.parse(strQuery);

                arrHist.push(this.$route.path.substr(1));
                strHist = JSON.stringify(arrHist);
                this.$cookie.set('history', strHist);

                arrQuery.push(this.$route.query.name);
                strQuery = JSON.stringify(arrQuery);
                this.$cookie.set('historyQuery', strQuery);

                this.$router.replace({ name: "newintervention", query:{name:name}});
            },
            goToBuildingPage(){
                var strHist = this.$cookie.get('history');
                var arrHist = JSON.parse(strHist);

                var strQuery = this.$cookie.get('historyQuery');
                var arrQuery = JSON.parse(strQuery);

                arrHist.push(this.$route.path.substr(1));
                strHist = JSON.stringify(arrHist);
                this.$cookie.set('history', strHist);

                arrQuery.push(this.$route.query.name);
                strQuery = JSON.stringify(arrQuery);
                this.$cookie.set('historyQuery', strQuery);

                this.$router.replace({ name: "buildinglist"});
            },
            goToNewBuildingPage(){
                var strHist = this.$cookie.get('history');
                var arrHist = JSON.parse(strHist);

                var strQuery = this.$cookie.get('historyQuery');
                var arrQuery = JSON.parse(strQuery);

                arrHist.push(this.$route.path.substr(1));
                strHist = JSON.stringify(arrHist);
                this.$cookie.set('history', strHist);

                arrQuery.push(this.$route.query.name);
                strQuery = JSON.stringify(arrQuery);
                this.$cookie.set('historyQuery', strQuery);

                this.$router.replace({ name: "newbuilding"});
            },
            goToPlanningPage(){
                var strHist = this.$cookie.get('history');
                var arrHist = JSON.parse(strHist);

                var strQuery = this.$cookie.get('historyQuery');
                var arrQuery = JSON.parse(strQuery);

                arrHist.push(this.$route.path.substr(1));
                strHist = JSON.stringify(arrHist);
                this.$cookie.set('history', strHist);

                arrQuery.push(this.$route.query.name);
                strQuery = JSON.stringify(arrQuery);
                this.$cookie.set('historyQuery', strQuery);

                this.$router.replace({ name: "planningadmin"});
            },
            goToTimeSheetPage(){
                var strHist = this.$cookie.get('history');
                var arrHist = JSON.parse(strHist);

                var strQuery = this.$cookie.get('historyQuery');
                var arrQuery = JSON.parse(strQuery);

                arrHist.push(this.$route.path.substr(1));
                strHist = JSON.stringify(arrHist);
                this.$cookie.set('history', strHist);

                arrQuery.push(this.$route.query.name);
                strQuery = JSON.stringify(arrQuery);
                this.$cookie.set('historyQuery', strQuery);

                this.$router.replace({ name: "timesheet"});
            },
            goToAllUserPage(){
                var strHist = this.$cookie.get('history');
                var arrHist = JSON.parse(strHist);

                var strQuery = this.$cookie.get('historyQuery');
                var arrQuery = JSON.parse(strQuery);

                arrHist.push(this.$route.path.substr(1));
                strHist = JSON.stringify(arrHist);
                this.$cookie.set('history', strHist);

                arrQuery.push(this.$route.query.name);
                strQuery = JSON.stringify(arrQuery);
                this.$cookie.set('historyQuery', strQuery);

                this.$router.replace({ name: "alluser"});
            },
            goToNewUserPage(){
                var strHist = this.$cookie.get('history');
                var arrHist = JSON.parse(strHist);

                var strQuery = this.$cookie.get('historyQuery');
                var arrQuery = JSON.parse(strQuery);

                arrHist.push(this.$route.path.substr(1));
                strHist = JSON.stringify(arrHist);
                this.$cookie.set('history', strHist);

                arrQuery.push(this.$route.query.name);
                strQuery = JSON.stringify(arrQuery);
                this.$cookie.set('historyQuery', strQuery);

                this.$router.replace({ name: "newuser"});
            },
            goToAllGroupPage(){
                var strHist = this.$cookie.get('history');
                var arrHist = JSON.parse(strHist);

                var strQuery = this.$cookie.get('historyQuery');
                var arrQuery = JSON.parse(strQuery);

                arrHist.push(this.$route.path.substr(1));
                strHist = JSON.stringify(arrHist);
                this.$cookie.set('history', strHist);

                arrQuery.push(this.$route.query.name);
                strQuery = JSON.stringify(arrQuery);
                this.$cookie.set('historyQuery', strQuery);

                this.$router.replace({ name: "allgroup"});
            },
            goToNewGroupPage(){
                var strHist = this.$cookie.get('history');
                var arrHist = JSON.parse(strHist);

                var strQuery = this.$cookie.get('historyQuery');
                var arrQuery = JSON.parse(strQuery);

                arrHist.push(this.$route.path.substr(1));
                strHist = JSON.stringify(arrHist);
                this.$cookie.set('history', strHist);

                arrQuery.push(this.$route.query.name);
                strQuery = JSON.stringify(arrQuery);
                this.$cookie.set('historyQuery', strQuery);

                this.$router.replace({ name: "newgroup"});
            },
            goToModifyInquiry(){
                var strHist = this.$cookie.get('history');
                var arrHist = JSON.parse(strHist);

                var strQuery = this.$cookie.get('historyQuery');
                var arrQuery = JSON.parse(strQuery);

                arrHist.push(this.$route.path.substr(1));
                strHist = JSON.stringify(arrHist);
                this.$cookie.set('history', strHist);

                arrQuery.push(this.$route.query.name);
                strQuery = JSON.stringify(arrQuery);
                this.$cookie.set('historyQuery', strQuery);

                this.$router.replace({ name: "modifyinquiry", query: {name:this.$route.query.name}});
            },
            goToNotePage(){
                this.$modal.show('notes');
            },
            openModal(){
                this.$modal.show('invoiceParam');
            },
            onInvoiceSelected(event){
                this.files = event.target.files;
                var extension = this.files[0].name.substring(this.files[0].name.lastIndexOf(".")+1).toLowerCase();
                if(extension !== "pdf"){
                    alert("Image au mauvais format, veuillez réessayer avec un fichier PDF");
                }
                else{
                    this.modifyInvoice();
                }       
                
            },
            async modifyNotes(){

                var response = await axios.put('https://so.gaviota.fr/api/building/inquiry/note/'+this.$route.query.name, {note:this.inquiry.note});
                
                if(response){
                    console.log(this.inquiry.note);
                    this.$modal.hide('notes');
                    if(this.inquiry.note.length > 100){
                        this.noteInq = this.inquiry.note.substr(0, 100)+"...";
                    }
                    else{
                        this.noteInq = this.inquiry.note;
                    }
                }                
            },
            async modifyQuotation(){
                const fd = new FormData();
                fd.append('picture', this.files[0] ,this.files[0].name);
                
                var response = await axios.put('https://so.gaviota.fr/api/building/inquiry/quotation/'+this.$route.query.name, fd);
                
                if(response){
                    this.inquiry.quotation = {};
                    this.inquiry.quotation._id  = response.data.id;
                    this.quotStatus = "à signer";
                    alert("Devis ajouté");
                }
            },
            async modifyInvoice(){

                const fd = new FormData();
                fd.append('picture', this.files[0] ,this.files[0].name);
                
                var val = parseInt(parseFloat(this.amount) * 100.0);
                if(!this.rolesSelected){
                    val = 0;  
                }
                
                var response = await axios.put('https://so.gaviota.fr/api/building/inquiry/invoice/'+this.$route.query.name+"/"+val, fd)
                
                if(response){
                    this.inquiry.invoice = {};
                    this.inquiry.invoice._id  = response.data.id;
                    this.invStatus = "à signer";
                    this.$modal.hide('invoiceParam');
                }
            },
            openNav(){
                 
                if(!this.navWidth){
                    this.navWidth = 300;
                }
                else{
                    this.navWidth = 0;
                }
                
                var vm = this;
                setTimeout(function(){
                    vm.navMenuVisible = !vm.navMenuVisible;
                }, 100);
            },
            reload() {
                this.$cookie.set('currentAriane', "");
                this.$cookie.set('history', "");
                this.$cookie.set('historyQuery', "");
                this.$router.replace({ name: "adminhome" });
            },
            goToInvoicePage(name){
                var strHist = this.$cookie.get('history');
                var arrHist = JSON.parse(strHist);

                var strQuery = this.$cookie.get('historyQuery');
                var arrQuery = JSON.parse(strQuery);

                arrHist.push(this.$route.path.substr(1));
                strHist = JSON.stringify(arrHist);
                this.$cookie.set('history', strHist);

                arrQuery.push(this.$route.query.name);
                strQuery = JSON.stringify(arrQuery);
                this.$cookie.set('historyQuery', strQuery);

                this.$router.replace({ name: "invoiceadmin", query: {name: name, id:this.$route.query.name}});
            },
            goToQuotationPage(name){
                var strHist = this.$cookie.get('history');
                var arrHist = JSON.parse(strHist);

                var strQuery = this.$cookie.get('historyQuery');
                var arrQuery = JSON.parse(strQuery);

                arrHist.push(this.$route.path.substr(1));
                strHist = JSON.stringify(arrHist);
                this.$cookie.set('history', strHist);

                arrQuery.push(this.$route.query.name);
                strQuery = JSON.stringify(arrQuery);
                this.$cookie.set('historyQuery', strQuery);

                this.$router.replace({ name: "quotationadmin", query: {name: name, id:this.$route.query.name}});
            },
            getDateOfIntervention(timestamp){
                
                var n = new Date(timestamp*1000);
                var y = n.getFullYear();
                var day = "0" + n.getDate();
                var month = "0" + (n.getMonth() + 1);
                return  day.substr(-2) + '/' + month.substr(-2) + '/' +y;
                            
            },	
            backbtn(){

                var strHist = this.$cookie.get('history');
                var arrHist = JSON.parse(strHist);
                var strQuery = this.$cookie.get('historyQuery');
                var arrQuery = JSON.parse(strQuery);
                
                this.$cookie.set('history', JSON.stringify(arrHist.slice(0, -1)));
                this.$cookie.set('historyQuery', JSON.stringify(arrQuery.slice(0, -1)));

                if(arrHist.length){
                    if(arrQuery[arrQuery.length-1] !== "" && arrQuery[arrQuery.length-1] !== "undefined"){
                        this.$router.replace({ name: arrHist[arrHist.length-1], query: {name: arrQuery[arrQuery.length-1]} });
                    }
                    else{
                        this.$router.replace({ name: arrHist[arrHist.length-1] });
                    }
                }
                else{
                    this.$cookie.set('currentAriane', "");
                    this.$router.replace({ name: "adminhome" });
                }
            },
            getCookies: function() {
                if(!this.$cookie.get('jwt') || !this.$cookie.get('role') || (this.$cookie.get('role') !== "admin" && this.$cookie.get('role') !== "technicien bureau") || !this.$route.query.name){
                    this.logout();
                }
                else{
                    this.Name = this.$cookie.get('firstName') +" "+this.$cookie.get('lastName');
                    this.getInquiries();
                }
            },
            async getInquiries(){
                axios.defaults.headers.common['Authorization'] = this.$cookie.get('jwt');
                var nameInq = this.$route.query.name.split('/').join('%2F');
                var response = await axios.get('https://so.gaviota.fr/api/building/inquiry/'+nameInq)
                if(response.data.inquiry){
                    console.log("ariane1 :")
                    this.inquiry = response.data.inquiry;
                    if(this.inquiry.document){
                        this.nbDocs = this.inquiry.document.length; 
                    }

                    if(this.inquiry.TVAsheet){
                        this.nbDocs = this.nbDocs+1;
                    }
                    if(this.inquiry.climsheet){
                        this.nbDocs = this.nbDocs+1;
                    }
                    if(this.inquiry.gazsheet){
                        this.nbDocs = this.nbDocs+1;
                    }
                    if(this.inquiry.fioulsheet){
                        this.nbDocs = this.nbDocs+1;
                    }

                    if(this.inquiry.quotation){
                        this.quotStatus = this.inquiry.quotation.status;
                        if(this.quotStatus === "en attente de devis"){
                            this.quotBtn = "Ajouter";
                        }
                    }
                    if(this.inquiry.invoice){
                        this.invStatus = this.inquiry.invoice.status;
                        if(this.invStatus === "en attente de facture"){
                            this.invBtn = "Ajouter";
                        }
                    }
                    if(this.inquiry.note){
                        if(this.inquiry.note.length > 100){
                            this.noteInq = this.inquiry.note.substr(0, 100)+"...";
                        }
                        else{
                            this.noteInq = this.inquiry.note;
                        }
                    }
                    if(this.$cookie.get('currentAriane').indexOf("Demande") > -1){
                        this.$cookie.set('currentAriane', this.$cookie.get('currentAriane').substr(0, this.$cookie.get('currentAriane').indexOf("Demande")-33));
                        this.$cookie.set('currentAriane', this.$cookie.get('currentAriane')+"&nbsp;&nbsp;<b>></b>&nbsp;&nbsp;"+" Demande "+this.$route.query.name+"&nbsp;&nbsp;-&nbsp;&nbsp;"+this.inquiry.type);
                    }
                    else{
                        this.$cookie.set('currentAriane', this.$cookie.get('currentAriane')+"&nbsp;&nbsp;<b>></b>&nbsp;&nbsp;"+" Demande "+this.$route.query.name+"&nbsp;&nbsp;-&nbsp;&nbsp;"+this.inquiry.type);
                    }
                    for(var i=0; i<this.inquiry.intervention.length; i++){
                        this.getIntervention(this.inquiry.intervention[i]._id)
                    }
                    this.filAriane = this.$cookie.get('currentAriane');
                    
                    var responseUser = await axios.get('https://so.gaviota.fr/api/userdata/'+this.inquiry.userInCharge.idWeweb)
                    if(responseUser.data.user){
                        this.followedBy = responseUser.data.user.address.firstName +" "+responseUser.data.user.address.lastName;
                    }
                }
            },
            displayTime(d){
                var h = Math.floor(d / 3600);
                var m = Math.floor(d % 3600 / 60);

                var hDisplay = h + "h ";
                var mDisplay = m + "min ";
                return hDisplay + mDisplay;
            },
            async getIntervention(name){
                axios.defaults.headers.common['Authorization'] = this.$cookie.get('jwt');
                var response = await axios.get('https://so.gaviota.fr/api/building/inquiry/intervention/light/'+name);
                if(response.data.intervention){
                    for(var j=0; j<response.data.intervention.planning.length; j++){
                        if(response.data.intervention.planning[j].isEstimated){
                            if(!response.data.intervention.isRemote){
                                if(response.data.intervention.planning[j].isMain){
                                    this.mainTechTime += response.data.intervention.planning[j].endTimestamp
                                                         - response.data.intervention.planning[j].startTimestamp;
                                }
                                else{
                                    if(response.data.intervention.planning[j].user.role === "interimaire"){
                                        this.interimTechTime += response.data.intervention.planning[j].endTimestamp
                                                             - response.data.intervention.planning[j].startTimestamp;
                                    }
                                    else{
                                        this.otherTechTime += response.data.intervention.planning[j].endTimestamp
                                                             - response.data.intervention.planning[j].startTimestamp;
                                    }
                                }
                            }
                            else{
                                if(response.data.intervention.planning[j].isMain){
                                    this.mainTechTimeDist += response.data.intervention.planning[j].endTimestamp
                                                         - response.data.intervention.planning[j].startTimestamp;
                                    this.mainTechTime += response.data.intervention.planning[j].endTimestamp
                                                         - response.data.intervention.planning[j].startTimestamp;
                                }
                                else{
                                    if(response.data.intervention.planning[j].user.role === "interimaire"){
                                        this.interimTechTimeDist += response.data.intervention.planning[j].endTimestamp
                                                             - response.data.intervention.planning[j].startTimestamp;
                                        this.interimTechTime += response.data.intervention.planning[j].endTimestamp
                                                             - response.data.intervention.planning[j].startTimestamp;
                                    }
                                    else{
                                        this.otherTechTimeDist += response.data.intervention.planning[j].endTimestamp
                                                             - response.data.intervention.planning[j].startTimestamp;
                                        this.otherTechTime += response.data.intervention.planning[j].endTimestamp
                                                             - response.data.intervention.planning[j].startTimestamp;
                                    }
                                }
                            }
                        }
                    }
                }
            },
            goToInquiryDocumentsPage(name){
                var strHist = this.$cookie.get('history');
                var arrHist = JSON.parse(strHist);

                var strQuery = this.$cookie.get('historyQuery');
                var arrQuery = JSON.parse(strQuery);

                arrHist.push(this.$route.path.substr(1));
                strHist = JSON.stringify(arrHist);
                this.$cookie.set('history', strHist);

                arrQuery.push(this.$route.query.name);
                strQuery = JSON.stringify(arrQuery);
                this.$cookie.set('historyQuery', strQuery);

                this.$router.replace({ name: "inquirydocumentsadmin", query: {name: name}});
            },
            goToInterventionPage(name){
                var strHist = this.$cookie.get('history');
                var arrHist = JSON.parse(strHist);

                var strQuery = this.$cookie.get('historyQuery');
                var arrQuery = JSON.parse(strQuery);

                arrHist.push(this.$route.path.substr(1));
                strHist = JSON.stringify(arrHist);
                this.$cookie.set('history', strHist);

                arrQuery.push(this.$route.query.name);
                strQuery = JSON.stringify(arrQuery);
                this.$cookie.set('historyQuery', strQuery);

                this.$router.replace({ name: "interventionadmin", query: {name: name}});
            }
        },
        mounted(){
            this.getCookies();
        }
    }
</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css?family=BenchNine');
    #inquiryadmin {
        width: 90%;
        background-color: #FFFFFF;
        margin: auto;
        margin-top: 60px;
        margin-bottom: 30px;
        border:none;
    }
    h1{
        background-color: #1ce83e;
        font-family: 'BenchNine', sans-serif;
        font-stretch: ultra-condensed;
        padding-bottom:15px;
        padding-top:15px;
        margin:0;
        font-size: 30px;
        font-weight: 600;
        display: block;
        text-align: center;
        position:relative;
    }
    @media screen and (max-width: 768px) {
        .h1 {
              font-size: 24px;
            }
    }
    nav{
        top:0px;
        left:0px;
        right:0px;
        margin: 0px;
        position:fixed;
        z-index:1;
        width:100%;
        background-color: white;
        border-bottom: 2px solid;
        border-color:#1ce83e;
    }
    .main{
        display: inline-block; 
        cursor: pointer;
        margin:5px;
    }

    .rightNav {
        position:absolute;
        top:0;
        right:0;
    }
    .innerNav {
        display: inline-block;
        position: relative;
    }

    .logoNav{
        vertical-align: middle;
        margin:5px;    
    }
    .navLogout{
        height: 20px;
        vertical-align: middle;
        cursor: pointer;
        margin:24px;
    }
    .leftNav{
        position:absolute;
        top:0;
        left:0;
    }   
    .pNav {
        display:inline-block;
        padding-right:15px;
        font-family: 'BenchNine', sans-serif;
        font-size: 20px;
        vertical-align: middle;
    }
    @media screen and (max-width: 768px) {
        .pNav {
              display: none;
            }
    }
    .homeName{
        margin:auto;
        font-family: 'BenchNine', sans-serif;
        font-size: 20px;
        text-align: center;
        margin:10px;
    }
    .outercircle{
        background-color: #F0F0F0;
        padding:50px;
    }
    .outermargin{
        background-color: #F0F0F0;
        padding:15px;
    }
    
    .baseBtn{
        font-family: 'BenchNine', sans-serif;
        font-stretch: ultra-condensed;
        font-weight: 400;
        font-size: 20px;
        display: block;
        border:none;
        margin: auto;
        width: 250px;
        color:#1ce83e;
        cursor: pointer;
        background-color: black;
        border-radius:10px;
    }
    .docBtn{
        margin:0px;
        width: 100px;
        position: absolute;
        top: 50%;
        right: 20px;
        -ms-transform: translateY(-50%);
        transform: translateY(-50%);
    }
    .card{
        font-family: 'BenchNine', sans-serif;
        margin:10px;
        margin-bottom:10px;
        background-color: #F0F0F0;
        display: inline-block;
        position: relative;
    }
    .btnCard{
        width:20px;
        height: 20px;
        border-radius: 50%;
        font-stretch: ultra-condensed;
        font-size: 15px;
        border:none;
        color:#1ce83e;
        cursor: pointer;
        background-color: black;
        display:inline-block;
        position: absolute;
        top: 50%;
        right: 20px;
        -ms-transform: translateY(-50%);
        transform: translateY(-50%);
    }
    .divCard{
        vertical-align: middle;
        position: relative;
        padding-left: 15px;
        padding-bottom: 25px;
        padding-top: 10px;
        border-bottom: 2px solid;
        border-color:#00000017;
    }
    .spanCardtype{
        display:inline-block;
        font-family: 'BenchNine', sans-serif;
        vertical-align: middle;
        font-size: 15px;
        position: absolute;
        left: 16px;
    }
    .spanCardstatus{
        display:inline-block;
        font-family: 'BenchNine', sans-serif;
        vertical-align: middle;
        font-size: 16px;
        position: absolute;
        right: 55px;
    }
    .spanCardtitle{
        display:block;
        font-family: 'BenchNine', sans-serif;
        font-size: 18px;
        font-weight: 700;
    }
   .btnBack{
        border:none;
        cursor: pointer;
        display: inline-block;
        text-align: left;
        background-color: #1ce83e;
        font-size: 30px;
        position: absolute;
        left: 1%;
        top: 50%;
        -ms-transform: translateY(-50%);
        transform: translateY(-50%);
    }
   .btnAccordion{
        font-family: 'BenchNine', sans-serif;
        font-size: 18px;
        font-weight: 700;
        border:none;
        cursor: pointer;
        width: calc(100% - (5px + 5px));
        display: inline-block;
        text-align: left;
        background-color: #FFF;
        margin: 5px;
    }
    .btnAccordionNone{
        cursor: default;
        padding-left:15px;
        -webkit-box-sizing: border-box; /* Safari/Chrome, other WebKit */
        -moz-box-sizing: border-box;    /* Firefox, other Gecko */
        box-sizing: border-box;         /* Opera/IE 8+ */
    }
    .filAriane{
        background-color: #F0F0F0;
        font-family: 'BenchNine', sans-serif;
        padding-top:20px;
        margin-left:-50px;
        margin-bottom:-17px;
        font-size: 17px;
    }
    button:disabled, button[disabled] {
        border: 1px solid #999999;
        background-color: #cccccc;
        color: #666666;
        cursor: no-drop;
    }		
    .sideNav{
        background-clip: border-box;
        background-color: #FFF;
        background-origin: padding-box;
        box-sizing: border-box;
        background-color: #333;
        display: block;
        height: 100%;
        overflow:auto;
        box-shadow: 8px 0px 6px -6px #999;
        position:fixed;
        top:0;
        left:0;
        z-index:10;
        -webkit-transition: width 0.5s;
        transition: width 0.5s;
    }
    .navsidecontent{
        color:white;
        font-family: 'BenchNine', sans-serif;
        margin-top:65px;
        margin-left:30px;
        margin-right:30px;
        -webkit-transition: width 0.5s;
        transition: width 0.5s;
    }
    .navtitle{
        margin:10px;
        margin-top:15px;
        padding-top:5px;
        font-size: 24px;
        font-weight: 700;
        text-align: center;
        border-top: 1px solid;
        border-color:#eee;
        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        cursor:default;
                              
    }
    .navsubtitle{
        margin:7px;
        font-size: 18px;
        font-weight: 400;
        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        cursor:pointer;
    }
    .navsubtitle:hover{
        color:#999;
    }
    .noborder{
        border:none;
        margin-top:5px;
        padding-top:0px;
    }
    .logout{
        padding-top:50px;
        cursor:pointer;
    }
    
	/* width */
	::-webkit-scrollbar {
		width: 6px;
	}
	
	/* Track */
	::-webkit-scrollbar-track {
		background: #ddd; 
	}
	
	/* Handle */
	::-webkit-scrollbar-thumb {
		background: #888; 
		border-radius: 3px;
	}
	
	/* Handle on hover */
	::-webkit-scrollbar-thumb:hover {
		background: #555; 
	}
    
    .btnNewBtn{
        width:25px;
        height: 25px;
        border-radius: 50%;
        font-stretch: ultra-condensed;
        font-size: 15px;
        border:none;
        color:black;
        cursor: pointer;
        background-color: #1ce83e;
        display:inline-block;
        position: absolute;
        right: 18px;
        top: 18px;
    }
    
    #modify{
        font-family: 'BenchNine', sans-serif;
        font-stretch: ultra-condensed;
        font-weight: 700;
        font-size: 20px;
        display: block;
        border: 2px solid;
        border-color:#1ce83e;
        margin: auto;
        width: 250px;
        color:#1ce83e;
        cursor: pointer;
        background-color: transparent;
        border-radius:10px;
    }
    .timeCumulated{
        font-family: 'BenchNine', sans-serif;
        font-size: 17px;
        background-color: #F0F0F0;
        display:inline-block;
    }
    hr{
        margin:0;
    }
    .outerTime{
        background-color: #F0F0F0;
    }
    .modalDiv{
        margin:30px;
        text-align: center;
    }
    .modalAmount{
        width:100px;
        margin:auto;
    }
    .modalTxt{
        font-family: 'BenchNine', sans-serif;
        font-stretch: ultra-condensed;
        font-size: 18px;
    }
    .txtDiv{
        margin-bottom: 15px; 
    }
    .modalNotes{
        background-color: #F0F0F0;
        resize: none;
        width:80%;
    }
    .modalCheck{
        width:100px;
        /* Double-sized Checkboxes */
        -ms-transform: scale(1.5); /* IE */
        -moz-transform: scale(1.5); /* FF */
        -webkit-transform: scale(1.5); /* Safari and Chrome */
        -o-transform: scale(1.5); /* Opera */
        transform: scale(1.5);
        padding-left: 45px;
        padding-right: 45px;
    }
    .docBtn3{
        font-family: 'BenchNine', sans-serif;
        font-stretch: ultra-condensed;
        display: inline-block;
        border:none;
        color:#1ce83e;
        font-size: 18px;
        cursor: pointer;
        background-color: black;
        border-radius:10px;
        width: 200px;
    }
</style>